// Reusable dashed vertical guide for chart hover state. Renders inside
// an SVG, so the parent owns the <svg> and viewBox math; this component
// only knows the x position and the y range to span.
//
// Brief: 1px stroke, 25% black, dash pattern "2 2". Identical across both
// charts so a viewer who pages between them gets the same hover affordance.

import { DASH, OPACITY, STROKE } from "./tokens";

export interface HoverCursorProps {
  /** X position in viewBox units. */
  x: number;
  /** Top of the cursor span (typically PAD_T). */
  y1: number;
  /** Bottom of the cursor span (typically baseline Y). */
  y2: number;
}

export function HoverCursor({ x, y1, y2 }: HoverCursorProps) {
  return (
    <line
      x1={x}
      x2={x}
      y1={y1}
      y2={y2}
      stroke="currentColor"
      strokeOpacity={OPACITY.cursor}
      strokeWidth={STROKE.cursor}
      strokeDasharray={DASH.cursor}
    />
  );
}

export default HoverCursor;
